<template>
  <div class="app-page">
    <RegisterSplashScreen v-if="isPublicRoute" />
    <Header helpURL="datasets/tutorials/annotations/">
      <template #extra-slot>
        <TaskEditModeCard
          v-if="mode === 'edit'"
          :annotationSetToEdit="annotationSetToEdit"
          :reviewSettings="reviewSettings"
          @update:annotation-set-to-edit="handleAnnotationSetToEditChanged"
          @stop-editing="handleStopEditing"
        />
      </template>
    </Header>
    <div class="main-page-div">
      <main class="main-display-area">
        <AnnotationEditor />
      </main>
    </div>
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { useRoute } from 'vue-router';
import { computed } from 'vue';
import Header from '@/components/Header.vue';
import AnnotationEditor from '@/components/DatasetComponent/AnnotationTool/AnnotationEditor.vue';
import TaskEditModeCard from '@/components/DatasetComponent/AnnotationTool/TaskEditModeCard.vue';
import RegisterSplashScreen from '@/components/RegisterSplashScreen.vue';
import { useEditorStore } from '@/stores/useEditorStore.js';
import { useEditorTaskStore } from '@/stores/useEditorTaskStore.js';

const route = useRoute();
const isPublicRoute = computed(() => route.path.includes('/public'));
const { mode, annotationSetToEdit } = storeToRefs(useEditorStore());
const { reviewSettings } = storeToRefs(useEditorTaskStore());

function handleAnnotationSetToEditChanged(set) {
  annotationSetToEdit.value = set;
  if (reviewSettings.value) {
    reviewSettings.value.reviewTask.source_annotation_set_id = set.id;
    reviewSettings.value.reviewTask.dest_annotation_set_id = set.id;
  }
}

function handleStopEditing() {
  annotationSetToEdit.value = null;
  if (reviewSettings.value) {
    reviewSettings.value = null;
  }
  mode.value = 'view';
}
</script>
